export default "__VITE_ASSET__a2bc0123__"